<template>
  <div class="wrapper">
    <div class="accordion" @click="toggleItem" :class="{open : open}">
      <h2 class="title">
        <slot name="title"></slot>
      </h2>
    </div>
    <div v-show="show" class="content">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    basic: {
      isShow: {
        default: false
      },
      isOpen: {
        default: false
      }
    }
  },
  components: {},
  data () {
    return {
      show: this.basic.isShow,
      open: this.basic.isOpen
    }
  },
  methods: {
    toggleItem () {
      this.show = !this.show
      if (this.show) {
        this.open = true
      } else {
        this.open = false
      }
    }
  }
}
</script>
<style scoped>
</style>
